import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import type { Contact } from '../types/contact';

type ContactWithCompany = Contact & {
  company?: {
    id: string;
    name: string;
  };
};

export function useContact(id: string) {
  const [contact, setContact] = useState<ContactWithCompany | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchContact = useCallback(async () => {
    try {
      const { data, error: fetchError } = await supabase
        .from('nrm_contacts')
        .select(`
          *,
          company:company_id (id, name)
        `)
        .eq('id', id)
        .single();

      if (fetchError) throw fetchError;
      setContact(data);
    } catch (err) {
      setError('Failed to load contact details');
      console.error('Fetch error:', err);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchContact();
  }, [fetchContact]);

  return { contact, loading, error, refetch: fetchContact };
}